import React, { useEffect, useState } from 'react';
import { Typography } from '@material-ui/core';
import { useStyles } from './styles';

interface IKpiCardProps {
  title: string;
  value: number | string;
  refValue?: number | string;
  subtitle: string;
  unit?: string;
}

const KpiCard: React.FC<IKpiCardProps> = ({
  title,
  value,
  refValue,
  subtitle,
  unit,
}) => {
  const classes = useStyles();
  const [color, setColor] = useState('#000000');

  useEffect(() => {
    if (Number(value) < Number(refValue)) {
      setColor('#2EB85C');
    } else if (Number(value) > Number(refValue)) {
      setColor('#E55353');
    } else {
      setColor('#000000');
    }
  }, [value, refValue]);

  return (
    <div className={classes.container}>
      <Typography variant="subtitle1">{title}</Typography>
      <Typography variant="h3" style={{ color }} className={classes.title}>
        {value === -1 ? '-' : Number(value).toFixed(0)}
      </Typography>
      <Typography variant="subtitle1">
        {refValue === -1
          ? `${subtitle}: -`
          : `${subtitle}: ${Number(refValue).toFixed(0)} ${unit || ''}`}
      </Typography>
    </div>
  );
};

export default KpiCard;
